// App.jsx
import React, { useRef, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import './App.css';
import './input.css';

import Navbar from './Components/NavBar';
import Hero from './Components/Hero';
import Courses from './Components/Courses';
import Services from './Components/Services';
import Certifications from './Components/Certifications';
import NeedCourses from './Components/NeedCourses';
import TestimonialsSection from './Components/TestimonialsSection';
import Footer from './Components/footer';

import CourseDetails from "./pages/CourseDetailPage";

import ScrollToTop from "./Components/ScrollToTop";
import CertificatesPage from "./pages/CertificationPage";
import AllCertifications from "./pages/AllCertifications";

const AppWrapper = () => {
  const coursesRef = useRef(null);
  const servicesRef = useRef(null);
  const certificationsRef = useRef(null);
  const needCoursesRef = useRef(null);
  const testimonialsRef = useRef(null);
  const location = useLocation();

  const scrollTo = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    const scrollKey = location.state?.scrollTo;
    const scrollMap = {
      home: { current: document.getElementById("home") },
      courses: coursesRef,
      services: servicesRef,
      certifications: certificationsRef,
      needCourses: needCoursesRef,
      testimonials: testimonialsRef,
    };

    if (scrollKey && scrollMap[scrollKey]) {
      scrollTo(scrollMap[scrollKey]);
    }
  }, [location]);

  return (
    <>
      <Navbar
        onScrollTo={{
          home: () => window.scrollTo({ top: 0, behavior: "smooth" }),
          courses: () => scrollTo(coursesRef),
          certifications: () => scrollTo(certificationsRef), // Services removed
          needCourses: () => scrollTo(needCoursesRef),
          testimonials: () => scrollTo(testimonialsRef),
        }}
      />
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <div id="home" className="pt-24"><Hero /></div>
              <div ref={coursesRef}><Courses /></div>
              {/* Services section removed here */}
              <div ref={certificationsRef}><Certifications /></div>
              <div ref={needCoursesRef}><NeedCourses /></div>
              <div ref={testimonialsRef}><TestimonialsSection /></div>
              <Footer />
            </>
          }
        />
        <Route path="/course/:id" element={<CourseDetails />} />
        <Route path="/all-certifications" element={<AllCertifications />} />
         <Route path="/certificates/:id" element={<CertificatesPage />} />

      </Routes>
    </>
  );
};

const App = () => (
  <Router>
    <AppWrapper />
  </Router>
);

export default App;
